/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { ensureI18nInitialized } from './i18n';
import store from './redux/Store';
import { registerPwaUpdateReload } from './registerPwa';
import { preloadAssetConfig } from './robot/robot-asset-manager';
import RobotService from './robot/robot-service';
import { registerBuildInfo } from './buildInfo';

registerPwaUpdateReload();

declare const window: Window &
  typeof globalThis & {
    robotService: RobotService;
  };
(async () => {
  const root = createRoot(document.getElementById('root')!);
  registerBuildInfo(window);
  window.robotService = new RobotService(store);
  preloadAssetConfig().catch(() => {});
  try {
    await ensureI18nInitialized();
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (err) {
    console.error('Failed to initialize i18n:', err);
    root.render(<div>Error initializing i18n</div>);
  }
})();
